import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-product-master-management',
  templateUrl: './product-master-management.component.html',
  styleUrls: ['./product-master-management.component.css']
})
export class ProductMasterManagementComponent implements OnInit {
  data: any;
  form: any | FormGroup
  modelSubtitle = false
  product:any = []
  checked = false
  name = ""
  version = ""
  code = ""
  group = ""
  description = ""
  isActive = false
  i: any;
  deleteId: any = "";
  cid:any
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  uomDropdownList:any = [];
  uomSelectedList:any = [];
  uomDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'uomMasterId',
    textField: 'uomName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  uomData:any = [];
  isDefault:any = ""
  ProductParams:any = []
  keyValueList:any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getallproduct()
    this.form = this.fb.group({
      name: [''],
      version: [''],
      group:[''],
      code:[''],
      description:['']
    })
    this.getAllUomMaster()
    this.getParamByType()
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.uomDropdownList = res.response
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  addProduct(){

    console.log(this.uomSelectedList)

    let supportedUOM:any = []

    for(let j = 0; j < this.uomSelectedList.length;j++) {
      for(let i = 0; i < this.uomDropdownList.length;i++) {
        if(this.uomSelectedList[j].uomMasterId == this.uomDropdownList[i].uomMasterId){
          if(this.uomSelectedList[j].uomMasterId == this.isDefault){
            supportedUOM.push(
              {
                "uomId": this.uomDropdownList[i].uomMasterId,
                "uomName": this.uomDropdownList[i].uomName,
                "cid": this.uomDropdownList[i].cid,
                "isDefault": true
              }
            )
          }else{
            supportedUOM.push(
              {
                "uomId": this.uomDropdownList[i].uomMasterId,
                "uomName": this.uomDropdownList[i].uomName,
                "cid": this.uomDropdownList[i].cid,
                "isDefault": false
              }
            )
          }
        }
      }
    }

    let keyValueList:any = []

    for(let i = 0; i < this.keyValueList.length; i++){
      keyValueList.push(
        {
          "key": this.keyValueList[i].key,
          "value": this.keyValueList[i].value
        }
      )
    }

    let body = {
        "createdBy": null,
        "createdDate": 0,
        "modifiedBy": null,
        "modifiedDate": 0,
        "version": String(this.form.get('version').value),
        "isActive": true,
        "description": String(this.form.get('description').value),
        "code": String(this.form.get('code').value),
        "name": String(this.form.get('name').value),
        "group": String(this.form.get('group').value),
        "supportedUOM": supportedUOM,
        "keyValueList": keyValueList,
        "status": "",
        "cid": this.cid
      }

    console.log(body)
    this.generic_service.addProduct(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getallproduct()
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getallproduct(){
    // this.generic_service.getProduct().subscribe(
    //   (response:any)=>{
    //     console.log(response)
    //     this.product = response.response;
    //   }
    // )
  }
 
  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.code = ""
    this.description = ""
    this.isActive = false
  }

  deleleProduct(){
    this.generic_service.delProduct(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success(res.message);
        this.getallproduct();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getallproduct();
  }

  getParamByType(){
    this.generic_service.getParamByType('PRODUCTPARAMS').subscribe(
      (response:any)=>{
        console.log(response);
        this.ProductParams = response.response;
        console.log(this.ProductParams);

        for(let i=0; i<this.ProductParams.length;i++){
          this.keyValueList.push(
            {
              "key": this.ProductParams[i].name,
              "value": "",
              "possibleValue": this.ProductParams[i].possibleValue
            }
          )
        }
        console.log(this.keyValueList);

      }
    )
  }

}

